module.exports = __webpack_public_path__ + "img/ffBanner_PC.e6c0695f.jpg";